import templateUrl from 'emun.commissioning/payperiods/payperiod-list.htm'
import controller from 'emun.commissioning/payperiods/payperiod-list.controller'

let PayPeriodList = {
    controller,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

export default PayPeriodList;